import "./index.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import { AuthProvider, useAuth } from "./context/AuthContext";
import Layout from "./components/Layout";
import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import Items from "./pages/Items";
import Transactions from "./pages/Transactions";
import Sales from "./pages/Sales";
import Reports from "./pages/Reports";
import Users from "./pages/Users";
import PriceList from "./pages/PriceList";
import HppList from "./pages/HppList";
import Debts from "./pages/Debts";
import MonthlyReport from "./pages/MonthlyReport";
import Attendance from "./pages/Attendance";
import ActivityLog from "./pages/ActivityLog";
import Damaged from "./pages/Damaged";
import { Loader2 } from "lucide-react";

function Protected({ children, perm, ownerOnly }) {
  const { user } = useAuth();
  if (user === null)
    return <div className="min-h-screen flex items-center justify-center"><Loader2 className="w-8 h-8 animate-spin" /></div>;
  if (user === false) return <Navigate to="/login" replace />;
  if (ownerOnly && !user.is_owner) return <Navigate to="/" replace />;
  if (perm && !(user.is_owner || user.perms?.[perm])) return <Navigate to="/" replace />;
  return children;
}

function LoginGate() {
  const { user } = useAuth();
  if (user) return <Navigate to="/" replace />;
  return <Login />;
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Toaster position="top-center" richColors />
        <Routes>
          <Route path="/login" element={<LoginGate />} />
          <Route element={<Protected><Layout /></Protected>}>
            <Route path="/" element={<Dashboard />} />
            <Route path="/barang" element={<Protected perm="stok"><Items /></Protected>} />
            <Route path="/harga" element={<Protected perm="prices"><PriceList /></Protected>} />
            <Route path="/hpp" element={<Protected perm="modal"><HppList /></Protected>} />
            <Route path="/transaksi" element={<Protected perm="mutasi"><Transactions /></Protected>} />
            <Route path="/penjualan" element={<Protected perm="penjualan"><Sales /></Protected>} />
            <Route path="/rusak" element={<Protected perm="rusak"><Damaged /></Protected>} />
            <Route path="/hutang" element={<Protected perm="hutang"><Debts /></Protected>} />
            <Route path="/absensi" element={<Protected perm="absensi"><Attendance /></Protected>} />
            <Route path="/laporan" element={<Protected perm="laporan"><Reports /></Protected>} />
            <Route path="/laporan-bulanan" element={<Protected perm="monthly"><MonthlyReport /></Protected>} />
            <Route path="/pengguna" element={<Protected ownerOnly><Users /></Protected>} />
            <Route path="/log-aktivitas" element={<Protected ownerOnly><ActivityLog /></Protected>} />
          </Route>
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
